import Icon from '../components/Icon.vue'

Icon.register({
  'truck-pickup': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 288H608V224C608 206.3 593.7 192 576 192H528L419.2 56A64-64 0 0 1 369.2 32H256C238.3 32 224 46.3 224 64V192H64C46.3 192 32 206.3 32 224V288H16C7.2 288 0 295.2 0 304V336C0 344.8 7.2 352 16 352H65.6C64.8 357.3 64 362.5 64 368 64 429.9 114.1 480 176 480S288 429.9 288 368C288 362.5 287.1 357.3 286.4 352H353.6C352.9 357.3 352 362.5 352 368 352 429.9 402.1 480 464 480S576 429.9 576 368C576 362.5 575.2 357.3 574.4 352H624C632.8 352 640 344.8 640 336V304C640 295.2 632.8 288 624 288zM288 96H369.2L446 192H288V96zM176 416C149.5 416 128 394.5 128 368S149.5 320 176 320 224 341.5 224 368 202.5 416 176 416zM464 416C437.5 416 416 394.5 416 368S437.5 320 464 320 512 341.5 512 368 490.5 416 464 416z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/truck-pickup.js
// module id = ttSG
// module chunks = 144